import React, { useState } from 'react';
import { Role } from '../types';
import { usePermissions } from '../hooks/usePermissions';
import PermissionGuard from '../components/Auth/PermissionGuard';
import UserList from '../components/Users/UserList';

const UserManagement: React.FC = () => {
  const [roles] = useState<Role[]>([]); // TODO: Load roles when needed
  // const [loading, setLoading] = useState(false); // TODO: Implement loading state
  // const [error, setError] = useState<string | null>(null); // TODO: Implement error handling
  
  const { canAccessModule } = usePermissions();

  // Check if user has access to user management
  if (!canAccessModule('users')) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You don't have permission to access user management.</p>
      </div>
    );
  }

  // TODO: Add loading and error states when implementing role loading

  return (
    <PermissionGuard module="users" action="read">
      <UserList roles={roles} />
    </PermissionGuard>
  );
};

export default UserManagement;